import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import { getOrderExpressList2, deleteOrderExpress, addOrderExpress, getOrderTransportList } from '@/services/order/orderDetail';
import { getTransportationCompanyList } from '@/services/systemsetting';
// const falseData = [
// 	{
// 		key:'1',
// 		id:111,
// 		orderNo:123123213123123,
// 		transportationName:'yamato',
// 		expressNo:32424234234,
// 		transportModeName:'常温',
// 		expressStatus:0,
// 		queryWay:'1',
// 	},
// 	{
// 		key:'2',
// 		id:112,
// 		orderNo:22222222222222222,
// 		transportationName:'西农',
// 		expressNo:123456456,
// 		transportModeName:'常温',
// 		expressStatus:1,
// 		queryWay:'2',
// 		queryUrl:'https://www.sf-express.com/we/ow/chn/sc/waybill/list?orderNo=',
// 	},
// 	{
// 			key:'4',
// 			id:114,
// 		orderNo:44444444444444444444,
// 		transportationName:'Runtech',
// 		expressNo:'',
// 		transportModeName:'冷藏',
// 		expressStatus:2,
// 		queryWay:'3',
// 	}
// ]
export default {
  name: 'orderDetailTransport',
  i18n: require('../i18n-orderDetail'),
  computed: {
    Columns: function Columns() {
      var columns = [
      // {
      // 	title: this.$t('orderDetailTransport.orderNo'),
      // 	dataIndex: 'orderNo',
      // 	key: 'orderNo',
      // },
      {
        //物流公司
        title: this.$t('orderDetailTransport.transportationName'),
        dataIndex: 'transportationName',
        key: 'transportationName'
      }, {
        //物流编号
        title: this.$t('orderDetailTransport.expressNo'),
        dataIndex: 'expressNo',
        key: 'expressNo'
      }, {
        //运输方式
        title: this.$t('orderDetailTransport.modeOfTransport'),
        dataIndex: 'transportModeName',
        key: 'transportModeName'
      }, {
        //物流状态
        title: this.$t('orderDetailTransport.expressStatus'),
        dataIndex: 'expressStatus',
        key: 'expressStatus',
        scopedSlots: {
          customRender: 'expressStatus'
        },
        width: "200px"
      }
      // {
      // 	title: this.$t('publicuse.action'),
      // 	dataIndex: 'action',
      // 	key: 'action',
      // 	scopedSlots: {
      // 		customRender: 'action'
      // 	},
      // 	width:"140px"
      // },
      ];
      return columns;
    },
    detailColumns: function detailColumns() {
      var columns = [{
        //订单编号
        title: this.$t('orderDetailTransport.orderNo'),
        dataIndex: 'orderNo',
        key: 'orderNo'
      }, {
        //物流公司
        title: this.$t('orderDetailTransport.transportationName'),
        dataIndex: 'transportationName',
        key: 'transportationName'
      }, {
        //物流编号
        title: this.$t('orderDetailTransport.expressNo'),
        dataIndex: 'expressNo',
        key: 'expressNo'
      }, {
        //物流状态
        title: this.$t('orderDetailTransport.expressStatus'),
        dataIndex: 'expressStatus',
        key: 'expressStatus'
      }, {
        //物流详情
        title: this.$t('orderDetailTransport.expressNo'),
        dataIndex: 'expressNo',
        key: 'expressNo'
      }];
      return columns;
    }
  },
  props: {
    orderInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var _this = this;
    var checkExpressNo = function checkExpressNo(rule, value, callback) {
      if (value !== '' && (value.length < 5 || value.length > 40)) {
        callback(new Error(_this.$t("orderDetailTransport.expressNoLenght")));
      } else {
        callback();
      }
    };
    return {
      orderId: "",
      //新增-订单编号
      orderNoList: [],
      //新增-物流公司
      TransportationList: [],
      // falseData,
      addVisible: false,
      addLoading: false,
      addModalValue: {},
      checkExpressNo: checkExpressNo,
      addRules: {
        id: [{
          required: true,
          message: this.$t("orderDetailTransport.noOrderNo"),
          trigger: 'change'
        }],
        transportationId: [{
          required: true,
          message: this.$t("orderDetailTransport.noTransportationName"),
          trigger: 'change'
        }],
        transportId: [{
          required: true,
          message: this.$t("orderDetailTransport.noModeOfTransport"),
          trigger: 'change'
        }],
        expressNo: [{
          required: false,
          validator: checkExpressNo,
          trigger: 'change'
        }]
      },
      //物流列表
      transportList: [],
      isTableLoading: false,
      transportNameList: [],
      //查看物流详情
      detailVisible: false,
      //物流详情列表
      transportDetailList: []
    };
  },
  mounted: function mounted() {
    this.orderId = this.$route.query.id;
    this.loadData();
  },
  methods: {
    //获取物流列表
    loadData: function loadData() {
      var _this2 = this;
      this.isTableLoading = true;
      getOrderExpressList2(this.orderId).then(function (response) {
        if (response.data.code == 200) {
          _this2.transportList = response.data.data;
        }
      }).finally(function () {
        _this2.isTableLoading = false;
      });
      // getOrderTransportList(this.orderId).then(response => {
      //   if ( response.data.code == 200 ) {
      //     this.transportNameList = response.data.data

      //   }
      // }).finally(() => {
      //   this.isTableLoading = false
      // })
    },
    //获取物流详情列表
    loadDetailList: function loadDetailList() {
      this.detailVisible = true;
    },
    // 获取物流状态
    getExpressStatus: function getExpressStatus(info) {
      switch (info) {
        case 0:
          return this.$t('public.expressStatus0');
        case 1:
          return this.$t('public.expressStatus1');
        case 2:
          return this.$t('public.expressStatus2');
        case 3:
          return this.$t('public.expressStatus3');
        case 4:
          return this.$t('public.expressStatus4');
        case 5:
          return this.$t('public.expressStatus5');
      }
    },
    //获取物流公司
    loadTransportationList: function loadTransportationList() {
      var _this3 = this;
      this.addVisible = true;
      if (this.TransportationList.length && this.TransportationList.length > 0) {
        this.addVisible = true;
      } else {
        getTransportationCompanyList().then(function (response) {
          if (response.data.code == 200) {
            _this3.TransportationList = response.data.data;
            _this3.addVisible = true;
          }
        });
      }
      this.addLoading = false;
    },
    //新增物流公司
    addHandle: function addHandle() {
      var _this4 = this;
      if (!this.addLoading && this.addVisible) {
        console.log(111);
        this.$refs.addRuleForm.validate(function (valid) {
          console.log(valid);
          if (valid) {
            _this4.addModalValue.id = _this4.orderId;
            _this4.addLoading = true;
            addOrderExpress(_this4.addModalValue).then(function (response) {
              if (response.data.code == 200) {
                _this4.$message.success(_this4.$t('public.updateSuccessfully'));
                _this4.addVisible = false;
                _this4.loadData();
                _this4.addModalValue = {};
              }
            }).finally(function () {
              _this4.$nextTick(function () {
                _this4.addLoading = false;
              });
            });
          }
        });
      }
    },
    //删除
    deleteTransport: function deleteTransport(id) {
      var _this5 = this;
      deleteOrderExpress(id).then(function (response) {
        if (response.data.code == 200) {
          _this5.loadData();
          _this5.$message.success(_this5.$t('public.deleteSuccessfully'));
        }
      });
    }
  }
};